import { render, staticRenderFns } from "./AdsRetention.vue?vue&type=template&id=3df3c0e5&scoped=true&"
import script from "./AdsRetention.vue?vue&type=script&lang=js&"
export * from "./AdsRetention.vue?vue&type=script&lang=js&"
import style0 from "./AdsRetention.vue?vue&type=style&index=0&id=3df3c0e5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3c0e5",
  null
  
)

export default component.exports